import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
    return (_openBlock(), _createBlock("small", {
      key: error.$uid,
      class: "d-block invalid-feedback"
    }, _toDisplayString(error.$message ?? error), 1))
  }), 128))
}